import { Injectable, resource, signal } from '@angular/core';
import { RestDatasource } from '@core/api/rest.datasource';
import { Pengeinstitut } from '@features/pengeinstitutter/pengeinstitut.model';
import { PiSearchParams } from '@features/pengeinstitutter/pi-search/pi-search-params.model';

@Injectable({
  providedIn: 'root',
})
export class PengeinstitutDatasource extends RestDatasource<Pengeinstitut> {
  override endpoint = '/api/admin/pengeinstitutter';
  searchParams = signal<PiSearchParams | undefined>(undefined);

  data = resource({
    params: () => this.searchParams(),
    loader: async ({ params, abortSignal }) => {
      return await this.getList(
        {
          filter: JSON.stringify(params),
          sortBy: 'navn',
        },
        abortSignal
      );
    },
  });
}
